import React, { useState, useEffect, useRef } from "react"
import MetaTags from "react-meta-tags"
import {
    Row,
    Col,
    Card,
    CardBody,
    Label,
    Button,
    Input,
    Badge
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { withRouter } from "react-router-dom"
import Modal from "react-bootstrap/Modal"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { ToastContainer, toast } from "react-toastify"
import * as emsAction from "../../store/bWFuYWdlRW1z/actions"
import { isEmpty } from "lodash"
import Select from "react-select"
import PhoneInput from "react-phone-number-input"
import SimpleReactValidator from "simple-react-validator"

const ManageEms = (props) => {
    const { SearchBar } = Search
    const { dispatch } = props

//emsData setEmsData initial state
    const [emsData, setEmsData] = useState({
        _id: "",
        bdmCode: "",
        bdmName: "",
        mobileNo: "",
        email: "",
        address: "",
        bdmUserName: "",
        bdmPassword: "",
        confirmPassword: "",

    })
    const [subSource, setSubSource] = useState([])

    const simpleValidator = useRef(new SimpleReactValidator(
        {
            validators: {
                password: {
                    message: 'The password must be at least 6 characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol.',
                    rule: (value) => {
                        return (
                            value.length >= 6 &&
                            /[A-Z]/.test(value) &&
                            /[a-z]/.test(value) &&
                            /\d/.test(value) &&
                            /[!@#$%^&*]/.test(value)
                        )
                    },
                },
                confirmPassword: {
                    message: "Confirm Password doesnot match password",

                    rule: (val, params) => {
                        const password = params[0] // Get the password field value from the params
                        return val === password
                    },
                }

            }
        }
    ))
    const [, forceUpdate] = useState()
    const simpleUpdateValidator = useRef(new SimpleReactValidator())
    const [, forcePrintUpdate] = useState()
    const update = useSelector((specificstate) => specificstate.manageEms)
    useEffect(() => {
        //dispatch(emsAction.loadRecords())
        dispatch(emsAction.loadRecordsMetaData())
    }, [])
    const { records = [],
        recordsMetaData = {}
    } = update

    const title = "Manage EMS"

    const [bdmmodal, setBdmModal] = useState(false)
    const [fullscreen, setFullscreen] = useState(false)
    const [editvendor, setEditvendor] = useState(false)
    const [deletemodal, setDeletemodal] = useState(false)



    const handleModal = () => {
        setBdmModal(false)
    }

    //table data
    let slNo = 0
    const vendorTable = !isEmpty(records) && records.length > 0 ?
        records.map((data) => {
            slNo = slNo + 1

            return {
                sNo: slNo,
                action: (<div style={{ display: "flex" }}>
                    <Button
                        type="submit"
                        onClick={() => {
                            setEditvendor(true)
                            setBdmModal(true)
                            updateVendor(data)
                            setFullscreen(true)


                        }}
                        style={{ fontSize: "8px", padding: "8px 10px" }}
                        className="btn btn-success buttons"
                    >
                        <i className="fas fa-pencil-alt icon-btn" ></i>
                    </Button>
                    <Button
                        type="submit"
                        onClick={() => {
                            setDeletemodal(true)
                            editdeleteModal(data)
                        }}
                        style={{ fontSize: "8px", marginLeft: "20px", padding: "8px 10px" }}
                        className="btn btn-danger buttons"
                    >
                        <i className="fas fa-trash-alt icon-btn" ></i>
                    </Button></div>
                ),
                bdmCode: data.bdmCode ? data.bdmCode : "--",
                bdmName: data.bdmName ? data.bdmName : "--",
                mobileNumber: data.mobileNo ? data.mobileNo : "--",
                emailId: data.emailId ? data.emailId : "--",
                userName: data.username ? data.username : "--",
                location: data.location ? data.location : "--",
                status: data.status,
                password: data.base64Password,
                subSource: data.leadSubSourceName
                    ? data.leadSubSourceName
                    : "--",
                _id: data._id,

            }
        }) : []

    //table columns
    const columns = [
        {
            dataField: "sNo",
            text: "S.No",
        },
        {
            dataField: "action",
            text: "Action",
            csvExport: false,
        },
        {
            dataField: "bdmCode",
            text: "Bdm Account Code",
            headerStyle: {
                minWidth: "170px",
            },
        },
        {
            dataField: "bdmName",
            text: "Bdm Account Name",
            headerStyle: {
                minWidth: "170px",
            },
        },

        {
            dataField: "mobileNumber",
            text: "Mobile Number",
            headerStyle: {
                minWidth: "160px",
            },
        },
        {
            dataField: "emailId",
            text: "Email Id",
            headerStyle: {
                minWidth: "130px",
            },
        },
        {
            dataField: "subSource",
            text: "Sub Source",
            headerStyle: {
                minWidth: "140px",
            },
        },
        {
            dataField: "location",
            text: "Location",
            headerStyle: {
                minWidth: "130px",
            },
        },
        {
            dataField: "userName",
            text: "User Name",
            headerStyle: {
                minWidth: "130px",
            },
        },

        {
            dataField: "status",
            text: "Status",
            formatter: (cellContent, row) => {

                const badgeClassName = row.status === 1 ? "bg-success badge-soft-success" : "bg-danger badge-soft-danger"
                const badgeName = row.status === 1 ? "Active" : "Inactive"
                return (
                    <div className="d-flex flex-row align-items-center">
                        <Badge className={`font-size-12 badge rounded-pill${badgeClassName}`} >
                            {badgeName}
                        </Badge>
                    </div>
                )
            },
            headerStyle: {
                minWidth: "100px",
            },
        },
    ]

    const [renderPage, setRenderPage] = useState(false)

    const handleChange = (e) => {
        setEmsData({
            ...emsData,
            [e.target.name]: e.target.value,
        })
    }

    // add bdm

    const addBdm = () => {
        const formValid = simpleValidator.current.allValid()


        if (formValid) {
            const record = {
                "username": emsData.bdmUserName,
                "password": emsData.confirmPassword,
                "bdmCode": emsData.bdmCode,
                "bdmName": emsData.bdmName,
                "mobileNo": emsData.mobileNo,
                "emailid": emsData.email,
                "location": emsData.address,
                "leadSubSourceId": subSource.value,

            }
            dispatch(emsAction.createRecord(record))
            setTimeout(() => {

                clearData()
                toast.success("Bdm Account Added successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 1000,
                })
                handleHideMessages()
            }, 500)
            setBdmModal(false)
            // setErrorMessageShow(false)
        }
        else {
            simpleValidator.current.showMessages()
            setRenderPage(!renderPage)
            forceUpdate(1)
        }
    }

    //update bdm modal
    const updateVendor = (data) => {
        const mobileNum = (data.mobileNo).toString()
        setEmsData({
            ...emsData, bdmCode: data.bdmCode,
            bdmName: data.bdmName,
            _id: data._id,
            mobileNo: mobileNum,
            email: data.emailId,
            address: data.location,
            bdmPassword: data.base64Password,
            confirmPassword: data.base64Password,
            bdmUserName: data.username,
        })
        setSubSource({ label:data.leadSubSourceName,value:data.leadSubSourceId })

    }

    //clear data
    const clearData = () => {
        setEmsData({
            _id: "",
            bdmCode: "",
            bdmName: "",
            mobileNo: "",
            email: "",
            address: "",
            bdmUserName: "",
            bdmPassword: "",
            confirmPassword: "",
        })
        setSubSource([])

    }
    //update bdm
    const updateBdm = () => {
        const formValidation = simpleUpdateValidator.current.allValid()
        if (formValidation) {
            const record = {
                "_id": emsData._id,
                "username": emsData.bdmUserName,
                "password": emsData.confirmPassword,
                "bdmCode": emsData.bdmCode,
                "bdmName": emsData.bdmName,
                "mobileNo": emsData.mobileNo,
                "emailId": emsData.email,
                "location": emsData.address,
                "leadSubSourceId": subSource.value,
            }
            dispatch(emsAction.updateRecord(record))
            setTimeout(() => {
                dispatch(emsAction.loadRecords())
                clearData()
                handleHideMessages()
                toast.success("Bdm Account Updated successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 1000,
                })
            }, 500)
            setBdmModal(false)
        }
        else {
            simpleUpdateValidator.current.showMessages()
            setRenderPage(!renderPage)
            forcePrintUpdate(1)
        }
    }
    //delete section

    const editdeleteModal = (vendor) => {
        setEmsData({ ...emsData, _id: vendor._id })
    }

    const deleteBdm = () => {
        const deleteData = {
            bdmId: [emsData._id],
            status: 3
        }
        dispatch(emsAction.deleteRecord(deleteData))
        setTimeout(() => {
            dispatch(emsAction.loadRecords())
            toast.success("Bdm Account Deleted successfully", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1000,
            })
        }, 500)
    }
    // password field icon show 
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)

    const handleHideMessages = () => {
        setShowPassword(false)
        setShowConfirmPassword(false)
        setBdmModal(false)
        setRenderPage(!renderPage)
        simpleValidator.current.hideMessages()
        simpleUpdateValidator.current.hideMessages()
    }

    const subSourceOptions =
    !isEmpty(recordsMetaData) && recordsMetaData.subSourceOptions
      ? recordsMetaData.subSourceOptions.filter(
          (data) => "6374e907f8640bcfdc0685f8"=== data.sourceId
        )
      : []
    return (
        <div className="page-content">
            <MetaTags>
                <title>{title} | Zero Gravity CRM</title>
            </MetaTags>

            <Breadcrumbs title={"Master"} breadcrumbItem={title} />
            <Row>
                <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                    <div className="filter-buttons" style={{ float: "right" }}>
                        <Button
                            style={{ backgroundColor: "#E40D8C", color: "white", border: "none", marginTop: "-35px" }}
                            onClick={() => {
                                setBdmModal(true)
                                setFullscreen(true)
                                setEditvendor(false)
                                clearData()

                            }}
                        >
                            Add Bdm Account
                        </Button>
                    </div>
                </Col>
            </Row>
            <Row className="mt-3 mb-5">
                <Col md="12" lg="12" xl="12">
                    <Card>
                        <CardBody>

                            <ToolkitProvider
                                keyField="_id"
                                data={vendorTable}
                                columns={columns}
                                search
                            >
                                {(props) => (
                                    <div>
                                        <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                            <Row className="d-flex flex-column">
                                                <Col className="mb-3">
                                                    <SearchBar {...props.searchProps} />
                                                </Col>
                                                <Col className="mb-6">
                                                    <BootstrapTable
                                                        {...props.baseProps}
                                                        pagination={paginationFactory()}
                                                        responsive
                                                        striped={true}
                                                        bordered={true}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </div>
                                )}
                            </ToolkitProvider>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            {bdmmodal && (
                <Modal
                    show={bdmmodal}
                    onHide={handleModal}
                    fullscreen={fullscreen}
                >
                    <Modal.Header
                        style={{
                            backgroundColor: "white",
                            color: "black",
                            fontSize: "16px",
                            fontWeight: "600",
                        }}
                    >
                        <Col xl="12" md="12" lg="12" sm="12" xs="12">
                            <div className="sales-modal-header">
                                <h4
                                    className="modal-title mt-0 sales-modal-title"
                                    id="myModalLabel"

                                >
                                    {editvendor ? "EDIT BDM ACCOUNT" : "ADD BDM ACCOUNT"}
                                </h4>
                                <span>
                                    <i
                                        className="fa fa-times quote-close"
                                        aria-hidden="true"
                                        onClick={() => setBdmModal(false)}
                                    ></i>
                                </span>
                            </div>
                        </Col>
                    </Modal.Header>
                    <Modal.Body >
                        {editvendor ? (
                            <Row>
                                <Card style={{
                                    backgroundColor: "rgba(211,211,211,0.13)", padding: "15px,15px,0px",
                                    border: "2px solid rgb(239, 242, 247)"
                                    , boxShadow: "none"
                                }}>
                                    <CardBody>
                                        <Row>
                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between" >
                                                    <Label className={"form-label"} htmlFor={"Vendor Code"}>
                                                        {"Bdm Account Code"}<span className="required ms-1">*</span>
                                                    </Label>
                                                </div>
                                                <Input
                                                    type="text"
                                                    name="bdmCode"
                                                    value={emsData.bdmCode}
                                                    onChange={(e) => handleChange(e)}
                                                    placeholder="Enter Bdm Account Code"
                                                />
                                                <div style={{ textTransform: "capitalize" }}>
                                                    {simpleUpdateValidator.current.message('Bdm Account Code', emsData.bdmCode, 'required')}
                                                </div>
                                            </Col>

                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label className={"form-label"} htmlFor={"Vendor Name"}>
                                                        {"Bdm Account Name"}<span className="required ms-1">*</span>
                                                    </Label>
                                                </div>

                                                <Input
                                                    type="text"
                                                    name="bdmName"
                                                    value={emsData.bdmName}
                                                    onChange={(e) => handleChange(e)}
                                                    placeholder="Enter Bdm Account Name"
                                                />
                                                <div style={{ textTransform: "capitalize" }}>
                                                    {simpleUpdateValidator.current.message('Bdm-Account Setup Name', emsData.bdmName, 'required')}
                                                </div>
                                            </Col>
                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label className={"form-label"} htmlFor={"Vendor Name"}>
                                                        {"Mobile Number"} <span className="required ms-1">*</span>
                                                    </Label>

                                                </div>


                                                <PhoneInput
                                                    maxlength={15}
                                                    international
                                                    countryCallingCodeEditable={
                                                        false
                                                    }
                                                    defaultCountry={"IN"}

                                                    style={{ flex: "2" }}
                                                    name="mobileNo"
                                                    value={emsData.mobileNo}
                                                    onChange={(e) => {
                                                        const re = /^[0-9\b/+]+$/
                                                        if (
                                                            e === "" ||
                                                            re.test(e)
                                                        ) {
                                                            handleChange({
                                                                target: {
                                                                    name: "mobileNo",
                                                                    value: e,
                                                                },
                                                            })
                                                        } else {
                                                            handleChange({
                                                                target: {
                                                                    name: "mobileNo",
                                                                    value: "",
                                                                },
                                                            })
                                                        }
                                                    }}
                                                    placeholder="+91"
                                                />
                                                <div style={{ textTransform: "capitalize" }}>
                                                    {simpleUpdateValidator.current.message('mobileNumber', emsData.mobileNo, 'required')}
                                                </div>
                                            </Col>
                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label
                                                        className={"form-label"}
                                                        htmlFor={"email"}
                                                    >
                                                        {"Email"}<span className="required ms-1">*</span>
                                                    </Label>
                                                </div>

                                                <Input
                                                    type="text"
                                                    name="email"
                                                    value={emsData.email}
                                                    onChange={(e) => handleChange(e)}
                                                    placeholder="Enter EmailId"
                                                />
                                                <div style={{ textTransform: "capitalize" }}>
                                                    {simpleUpdateValidator.current.message('email', emsData.email, 'required|email')}
                                                </div>
                                            </Col>
                                          
                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label className={"form-label"} htmlFor={"Sub Source"}>
                                                        {"Sub Source"}<span className="required ms-1">*</span>
                                                    </Label>
                                                </div>
                                                <Select
                                                    name="subSource"
                                                    value={subSource}
                                                    onChange={(e) => setSubSource(e)}
                                                    options={subSourceOptions}
                                                    placeholder="Select SubSource"
                                                    classNamePrefix="select2-selection"
                                                />
                                            </Col>
                                            <Col lg="6" md="6" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label className={"form-label"} htmlFor={"Address"}>
                                                        {"Address"}<span className="required ms-1">*</span>
                                                    </Label>
                                                </div>

                                                <Input
                                                    type="textarea"
                                                    name="address"
                                                    value={emsData.address}
                                                    onChange={(e) => handleChange(e)}
                                                    placeholder="Enter Address"
                                                />
                                                <div style={{ textTransform: "capitalize" }}>
                                                    {simpleUpdateValidator.current.message('address', emsData.address, 'required')}
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Row>) : (<>
                                <Row>
                                    <Card style={{
                                        backgroundColor: "rgba(211,211,211,0.13)", padding: "15px,15px,0px",
                                        border: "2px solid rgb(239, 242, 247)"
                                        , boxShadow: "none"
                                    }}>
                                        <CardBody>
                                            <Row>
                                                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                    <div className="d-flex justify-content-between" >
                                                        <Label className={"form-label"} htmlFor={"Vendor Code"}>
                                                            {"Bdm Account Code"}<span className="required ms-1">*</span>
                                                        </Label>
                                                    </div>
                                                    <Input
                                                        type="text"
                                                        name="bdmCode"
                                                        value={emsData.bdmCode}
                                                        onChange={(e) => handleChange(e)}
                                                        placeholder="Enter Bdm Account Code"
                                                    />
                                                    <div style={{ textTransform: "capitalize" }}>
                                                        {simpleValidator.current.message('Bdm-Account Setup Code', emsData.bdmCode, 'required')}
                                                    </div>
                                                </Col>

                                                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                    <div className="d-flex justify-content-between">
                                                        <Label className={"form-label"} htmlFor={"Vendor Name"}>
                                                            {"Bdm Account Name"}<span className="required ms-1">*</span>
                                                        </Label>
                                                    </div>

                                                    <Input
                                                        type="text"
                                                        name="bdmName"
                                                        value={emsData.bdmName}
                                                        onChange={(e) => handleChange(e)}
                                                        placeholder="Enter Bdm Account Name"
                                                    />
                                                    <div style={{ textTransform: "capitalize" }}>
                                                        {simpleValidator.current.message('Bdm-Account Setup Code', emsData.bdmName, 'required')}
                                                    </div>
                                                </Col>
                                                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                    <div className="d-flex justify-content-between">
                                                        <Label className={"form-label"} htmlFor={"Vendor Name"}>
                                                            {"Mobile Number"} <span className="required ms-1">*</span>
                                                        </Label>

                                                    </div>


                                                    <PhoneInput
                                                        maxlength={15}
                                                        international
                                                        countryCallingCodeEditable={
                                                            false
                                                        }
                                                        defaultCountry={"IN"}

                                                        style={{ flex: "2" }}
                                                        name="mobileNo"
                                                        value={emsData.mobileNo}
                                                        onChange={(e) => {
                                                            const re = /^[0-9\b/+]+$/
                                                            if (
                                                                e === "" ||
                                                                re.test(e)
                                                            ) {
                                                                handleChange({
                                                                    target: {
                                                                        name: "mobileNo",
                                                                        value: e,
                                                                    },
                                                                })
                                                            } else {
                                                                handleChange({
                                                                    target: {
                                                                        name: "mobileNo",
                                                                        value: "",
                                                                    },
                                                                })
                                                            }
                                                        }}
                                                        placeholder="+91"
                                                    />
                                                    <div style={{ textTransform: "capitalize" }}>
                                                        {simpleValidator.current.message('mobileNumber', emsData.mobileNo, 'required')}
                                                    </div>
                                                </Col>
                                                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                    <div className="d-flex justify-content-between">
                                                        <Label
                                                            className={"form-label"}
                                                            htmlFor={"email"}
                                                        >
                                                            {"Email"}<span className="required ms-1">*</span>
                                                        </Label>
                                                    </div>

                                                    <Input
                                                        type="text"
                                                        name="email"
                                                        value={emsData.email}
                                                        onChange={(e) => handleChange(e)}
                                                        placeholder="Enter EmailId"
                                                    />
                                                    <div style={{ textTransform: "capitalize" }}>
                                                        {simpleValidator.current.message('email', emsData.email, 'required|email')}
                                                    </div>
                                                </Col>
                                             
                                                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                    <div className="d-flex justify-content-between">
                                                        <Label className={"form-label"} htmlFor={"Sub Source"}>
                                                            {"Sub Source"}<span className="required ms-1">*</span>
                                                        </Label>
                                                    </div>
                                                    <Select
                                                        name="subSource"
                                                        value={subSource}
                                                        onChange={(e) => setSubSource(e)}
                                                        options={subSourceOptions}
                                                        placeholder="Select SubSource"
                                                        classNamePrefix="select2-selection"
                                                    />
                                                    <div style={{ textTransform: "capitalize" }}>
                                                        {simpleValidator.current.message('SubSource', subSource, 'required')}
                                                    </div>
                                                </Col>
                                                <Col lg="6" md="6" sm="12" xs="12" className="mt-3">
                                                    <div className="d-flex justify-content-between">
                                                        <Label className={"form-label"} htmlFor={"Address"}>
                                                            {"Address"}<span className="required ms-1">*</span>
                                                        </Label>
                                                    </div>

                                                    <Input
                                                        type="textarea"
                                                        name="address"
                                                        value={emsData.address}
                                                        onChange={(e) => handleChange(e)}
                                                        placeholder="Enter Address"
                                                    />
                                                    <div style={{ textTransform: "capitalize" }}>
                                                        {simpleValidator.current.message('address', emsData.address, 'required')}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Row>
                                <Row>
                                    <Card style={{
                                        backgroundColor: "rgba(211,211,211,0.13)",
                                        padding: "15px,15px,0px", border: "2px solid rgb(239, 242, 247)"
                                        , boxShadow: "none"
                                    }}>
                                        <CardBody>
                                            <Row className="mt-2">
                                                <Col lg="9" md="9" sm="12">
                                                    <p
                                                        style={{
                                                            margin: "0px",
                                                            marginRight: "15px",
                                                            marginTop: "15px",
                                                            fontSize: "16px",
                                                            fontWeight: "500",
                                                        }}
                                                    >
                                                        Login Credentials
                                                    </p></Col>
                                            </Row>
                                            <Row>
                                                <Col lg="3" md="3" sm="12" className="mt-3">
                                                    <div className="d-flex justify-content-between">
                                                        <Label className={"form-label"} htmlFor={"Address"}>
                                                            {"Username"}<span className="required ms-1">*</span>
                                                        </Label>
                                                    </div>
                                                    <Input
                                                        type="text"
                                                        name="bdmUserName"
                                                        value={emsData.bdmUserName}
                                                        onChange={(e) => handleChange(e)}
                                                        placeholder="Enter Username"
                                                        autoComplete="off"
                                                    ></Input>
                                                    <div style={{ textTransform: "capitalize" }}>
                                                        {simpleValidator.current.message('UserName', emsData.bdmName, 'required')}
                                                    </div>
                                                </Col>
                                                <Col lg="3" md="3" sm="12" className="mt-3">
                                                    <div className="d-flex justify-content-between">
                                                        <Label className={"form-label"} htmlFor={"Address"}>
                                                            {"Password"}<span className="required ms-1">*</span>
                                                        </Label>
                                                    </div>
                                                    <div className="d-flex">
                                                        <Input
                                                            type={showPassword ? 'text' : 'password'}
                                                            name="bdmPassword"
                                                            value={emsData.bdmPassword}
                                                            onChange={(e) => handleChange(e)}
                                                            placeholder="Enter Password"
                                                            autoComplete="off"
                                                        ></Input>
                                                        <span
                                                            onClick={() => setShowPassword(!showPassword)}
                                                            style={{ cursor: 'pointer', marginLeft: "-30px", marginTop: "10px" }}
                                                        >
                                                            {showPassword ? <i className="fas fa-eye-slash  fs-5"></i> : <i className="fas fa-eye  fs-5"></i>}
                                                        </span>
                                                    </div>
                                                    <div style={{ textTransform: "capitalize" }}>
                                                        {simpleValidator.current.message('Password', emsData.bdmPassword, 'required|password')}
                                                    </div>
                                                </Col>
                                                <Col lg="3" md="3" sm="12" className="mt-3">
                                                    <div className="d-flex justify-content-between">
                                                        <Label className={"form-label"} htmlFor={"Address"}>
                                                            {"Confirm Password"}<span className="required ms-1">*</span>
                                                        </Label>
                                                    </div>
                                                    <div className="d-flex">
                                                        <Input
                                                            type={showConfirmPassword ? 'text' : 'password'}
                                                            name="confirmPassword"
                                                            value={emsData.confirmPassword}
                                                            onChange={(e) => handleChange(e)}
                                                            placeholder="Enter Confirm Password"
                                                        // autoComplete="off"
                                                        ></Input>

                                                        <span
                                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                            style={{ cursor: 'pointer', marginLeft: "-30px", marginTop: "10px" }}
                                                        >
                                                            {showConfirmPassword ? <i className="fas fa-eye-slash  fs-5"></i> : <i className="fas fa-eye fs-5"></i>}
                                                        </span>

                                                    </div>
                                                    <div style={{ textTransform: "capitalize" }}>
                                                        {simpleValidator.current.message('Confirm Password', emsData.confirmPassword, `required|password|confirmPassword:${emsData.bdmPassword}`)}
                                                    </div>

                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Row></>
                        )}

                    </Modal.Body>
                    <Modal.Footer>
                        <Col >
                            <div style={{ float: "right" }}>
                                <Button
                                    variant="secondary"
                                    className="btn btn-danger"
                                    onClick={() => handleHideMessages()}
                                >
                                    Cancel
                                </Button>

                                {editvendor ? (<Button
                                    style={{ marginLeft: "20px" }}
                                    variant="primary"
                                    className="btn btn-success"
                                    onClick={() => {
                                        updateBdm()
                                    }}
                                >
                                    {"Update"}
                                </Button>) : (<Button
                                    style={{ marginLeft: "20px" }}
                                    variant="primary"
                                    className="btn btn-success"
                                    onClick={() => {
                                        addBdm()
                                    }}
                                >
                                    {"Add"}
                                </Button>)}
                            </div>
                        </Col>
                    </Modal.Footer>
                </Modal>
            )}
            {deletemodal && (
                <Modal show={deletemodal} size="md">
                    <Modal.Header
                        style={{
                            backgroundColor: "#E40D8C",
                            color: "white",
                            minHeight: "65px",
                            fontSize: "16px",
                            fontWeight: "600",
                        }}
                    >
                        Delete Bdm Account
                    </Modal.Header>
                    <Modal.Body> Are You Sure You Want To Delete This?</Modal.Body>
                    <Modal.Footer>
                        <div>
                            <Button
                                type="submit"
                                onClick={() => {
                                    deleteBdm()
                                    setTimeout(() => { setDeletemodal(false) }, 500)
                                }}
                                style={{ fontSize: "10px", marginLeft: "20px" }}
                                className="btn btn-success buttons"
                            > Yes</Button>
                            <Button
                                type="submit"
                                onClick={() => {
                                    setDeletemodal(false)
                                }}
                                style={{ fontSize: "10px", marginLeft: "20px" }}
                                className="btn btn-danger buttons"
                            > No
                            </Button>
                        </div>
                    </Modal.Footer>
                </Modal>)}
            <ToastContainer
                position="top-right"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    )
}
ManageEms.propTypes = {
    searchProps: PropTypes.func,
    baseProps: PropTypes.any,
    csvProps: PropTypes.any,
    searchBarStyle: PropTypes.any,
    dispatch: PropTypes.func,
}
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    }
}
const mapStateToProps = () => ({
    // employee: state.employeeRequest.employee,
})
//ManageEms
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ManageEms)
)
